export type TagsResponse = string[]
export interface TagsRequest {
  name: string
  data?: string
}

export interface ConsumerTag {
  [key: string]: string
}

/** tag names */
export const BIOMETRIC_DENIED_COUNT_KEY = 'biometric-denied-count'
export const BIOMETRIC_LAST_DENIED_DATE_KEY = 'biometric-last-denied-date'
